import styled from 'styled-components'
import {
  CheckboxCustom,
  CheckboxInput,
  CheckboxWrap,
} from 'ui/components/forms/Checkbox/styled'

export const LinkStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const PublishedFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  ${CheckboxWrap} {
    cursor: default;
  }

  ${CheckboxWrap}:hover ${CheckboxCustom} {
    background-color: var(--t-checkbox-custom-disable-bg);
    border-color: var(--t-checkbox-custom-disable-bg);
  }

  ${CheckboxCustom} {
    background-color: var(--t-checkbox-custom-disable-bg);
    border-color: var(--t-checkbox-custom-disable-bg);
    color: var(--t-checkbox-custom-disable-color);
  }

  ${CheckboxCustom}:hover {
    background-color: var(--p-neutral-680);
    border-color: var(--p-neutral-680);
  }

  ${CheckboxInput}:checked ~ ${CheckboxCustom} {
    background-color: var(--t-checkbox-custom-disable-bg);
    border-color: var(--t-checkbox-custom-disable-bg);
    color: var(--t-checkbox-custom-disable-color);
  }

  ${CheckboxWrap} span:last-child {
    color: var(--t-checkbox-custom-disable-color);
  }
`

export const TextStyled = styled.div``
